import moment from 'moment';

export default function (time, timezone) {
  const momentTime = timezone
    ? moment.utc(time).tz(timezone)
    : moment.utc(time).local();

  const hour = momentTime.format('h:mm A');
  const date = momentTime.format('do MMMM');

  let text = `Task done at ${hour}`;

  const today = timezone
    ? moment.utc().tz(timezone)
    : moment.utc().local();

  if (!today.isSame(momentTime, 'day')) {
    text = `${text} on ${date}`;
  }

  return text;
};
